import { DropdownMenuItem } from '@/components/shadcn/dropdown-menu'
import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { CellContext } from '@tanstack/react-table'
import { SheetWithFormComponent } from '@/components/ui/SheetWithFormComponent'
import { Suspense, useState } from 'react'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { IconCommentOutline } from '@icons/IconCommentOutline'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { DataTableV2CollaborationAction } from '../../types'
import { FormComponentLoading } from '../../../FormComponent'
import { CollaborationSheetContent } from './CollaborationSheetContent'

type CollaborationItemProps<T, V> = {
  action: DataTableV2CollaborationAction
  info: CellContext<T, V>
  displayAs?: 'dropdown-item' | 'icon-button'
}

export function CollaborationMenuItemV2<T, V>({ action, info, displayAs = 'dropdown-item' }: CollaborationItemProps<T, V>) {
  const [sheetOpen, setSheetOpen] = useState(false)
  const isIconButton = displayAs === 'icon-button'

  const trigger = isIconButton ? (
    <TooltipButton tooltip={action.label}>
      <Button variant="ghost" size="icon" className="size-6" disabled={action.isDisabled}>
        <DynamicIcon
          iconName={action.icon || ''}
          lazyLoad={false}
          fallback={<IconCommentOutline className="size-3" />}
        />
        <span className="sr-only">{action.label}</span>
      </Button>
    </TooltipButton>
  ) : (
    <div onClick={(e) => e.stopPropagation()}>
      <DropdownMenuItem onSelect={(e) => e.preventDefault()} disabled={action.isDisabled}>
        <div className="flex items-center gap-2">
          <DynamicIcon
            iconName={action.icon || ''}
            lazyLoad={false}
            className="size-3"
            fallback={<IconCommentOutline className="size-3" />}
          />
          <span>{action.label}</span>
        </div>
      </DropdownMenuItem>
    </div>
  )

  return (
    <SheetWithFormComponent
      title={action.label}
      // description="Collaboration description goes here."
      trigger={trigger}
      wide
      isOpen={sheetOpen}
      onOpenChange={setSheetOpen}
    >
      <QueryErrorBoundary errorMessage="Failed to fetch channel thread details">
        <Suspense fallback={<FormComponentLoading />}>
          <CollaborationSheetContent action={action} info={info} />
        </Suspense>
      </QueryErrorBoundary>
    </SheetWithFormComponent>
  )
}
